import type { DailyTaskClaim } from "@newfungame/contracts";

export interface TasksActions {
  /** «Забрать» в окне заданий дня: окно остаётся открытым, ответ сервера обновляет его. */
  claimTask(task: DailyTaskClaim): void;
  /** Окно заданий открыто (аналитика). */
  tasksOpened(claimable: number): void;
}

const noop = () => {};

export const defaults: TasksActions = {
  claimTask: noop,
  tasksOpened: noop,
};

declare module "../actions" {
  interface WindowActions extends TasksActions {}
}
